import {
  cibSkype,
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  // cibStackOverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  cibCcAmex
} from '@coreui/icons'
import {
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl
} from '@coreui/icons'
import {
  cilAlignCenter,
  cilAlignLeft,
  cilAlignRight,
  cilApplicationsSettings,
  cilArrowLeft,
  cilLocationPin,
  cilArrowRight,
  cilTag,
  cilBan,
  cilBasket,
  cilBell,
  cilBold,
  cilBook,
  cilBookmark,
  cilCalculator,
  cilCalendar,
  cilCloudDownload,
  cilChatBubble,
  cilChartLine,
  cilChartPie,
  cilCheck,
  cilChevronBottom,
  cilChevronLeft,
  cilChevronRight,
  cilChevronTop,
  cilCircle,
  cilCheckCircle,
  cilCode,
  cilColorBorder,
  cilCommentSquare,
  cilCopy,
  cilCreditCard,
  cilCursor,
  cilCursorMove,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeLetter,
  cilEnvelopeOpen,
  cilEuro,
  cilGlobeAlt,
  cilGrid,
  cilBarChart,
  cilFile,
  cilFullscreen,
  cilFullscreenExit,
  cilHome,
  cilInbox,
  cilIndentDecrease,
  cilIndentIncrease,
  cilInputPower,
  cilInstitution,
  cilItalic,
  cilJustifyCenter,
  cilJustifyLeft,
  cilMedicalCross,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilListNumbered,
  cilListRich,
  cilTruck,
  cilLockLocked,
  cilLockUnlocked,
  cilMagnifyingGlass,
  cilMap,
  cilMoon,
  cilNotes,
  cilOptions,
  cilPaperclip,
  cilPaperPlane,
  cilPencil,
  cilPeople,
  cilPhone,
  cilBuilding,
  cilPrint,
  cilPuzzle,
  cilSave,
  cilSearch,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilSun,
  cilTags,
  cilTask,
  cilTrash,
  cilUnderline,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilUserUnfollow,
  cilXCircle,
  cilWarning,
  // cilImage1,
  cilPin,
  cilPlus,
  // cilPlusCircle,
  cilMoney,
  cilClock,
  cilCommentBubble,
  cilHouse,
  cilLink,
  cilArrowTop,
  cilArrowBottom,
  cilGift,
  cilAddressBook,
  cilContact,
  cilReload,
  cilGraph,
  cilDataTransferDown,
  cilInfo,
  cilFlagAlt,
  cilAsteriskCircle,
  cilAvTimer,
  cilWallet,
  cilMinus,
  cilDescription,
  cilExitToApp,
  cilHistory,
  cilWalk,
  cilWc,
  cilSchool,
  cilSnowflake,
  cilBoatAlt,
  cilBellExclamation,
  cilBolt,
  cilZoom,
  cilAccountLogout,
  cilPlaylistAdd
} from '@coreui/icons'
import { logo } from './logo'
import { sterilization } from './sterilization';


export const iconsSet = Object.assign({}, { logo },{ sterilization }, {
  cilAlignCenter,
  cilDescription,
  cilLink,
  cilAlignLeft,
  cilLocationPin,
  cilBellExclamation,
  cilSnowflake,
  cilBolt,
  cilArrowBottom,
  cilArrowTop,
  cilSchool,
  cilAccountLogout,
  cilPlaylistAdd,
  cilAlignRight,
  cilBarChart,
  cilZoom,
  cilApplicationsSettings,
  cilArrowLeft,
  cilArrowRight,
  cilBan,
  cilBasket,
  cilDataTransferDown,
  cilBell,
  cilBold,
  cilBook,
  cilBookmark,
  cilLockUnlocked,
  cilCalculator,
  cilCalendar,
  cilBuilding,
  cilTruck,
  cilCloudDownload,
  cilChatBubble,
  cilChartLine,
  cilChartPie,
  cilCheck,
  cilChevronBottom,
  cilChevronLeft,
  cilChevronRight,
  cilChevronTop,
  cilTag,
  cilMedicalCross,
  cilCircle,
  cilCheckCircle,
  cilHouse,
  cilCode,
  cilColorBorder,
  cilCommentSquare,
  cilCommentBubble,
  cilCopy,
  cilCreditCard,
  cilCursor,
  cilCursorMove,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeLetter,
  cilEnvelopeOpen,
  cilEuro,
  cilGlobeAlt,
  cilGrid,
  cilGraph,
  cilFile,
  cilFullscreen,
  cilFullscreenExit,
  cilHome,
  cilInbox,
  cilIndentDecrease,
  cilIndentIncrease,
  cilInputPower,
  cilInstitution,
  cilItalic,
  cilJustifyCenter,
  cilJustifyLeft,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilListNumbered,
  cilListRich,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMap,
  cilMoon,
  cilNotes,
  cilOptions,
  cilPaperclip,
  cilPaperPlane,
  cilPencil,
  cilPeople,
  cilPhone,
  cilPrint,
  cilPuzzle,
  cilSave,
  cilSearch,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilSun,
  cilTags,
  cilTask,
  cilTrash,
  cilUnderline,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilUserUnfollow,
  cilXCircle,
  cilWarning,
  // cilImage1,
  cilPin,
  cilPlus,
  // cilPlusCircle,
  cilMoney,
  cilClock,
  cilGift,
  cilAddressBook,
  cilContact,
  cilReload,
  cilInfo,
  cilFlagAlt,
  cilAsteriskCircle,
  cilAvTimer,
  cilWallet,
  cilMinus,
  cilExitToApp,
  cilHistory,
  cilWalk,
  cilWc,
  cilBoatAlt
}, {
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl
}, {
  cibSkype,
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  // cibStackOverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  cibCcAmex
})


